import { z, ZodType } from 'zod';
import { TurnStatus, turnStatusesSchema } from './turn-status';

export type Turn = {
	mines: number[][];
	turnHistory: number[];
	multiplier: number;
	status: TurnStatus;
	profit: number;
	serverSeed?: string;
};

export const turnSchema: ZodType<Turn> = z.object({
	mines: z.number().array().array(),
	turnHistory: z.number().array(),
	multiplier: z.number(),
	status: turnStatusesSchema,
	profit: z.number(),
	serverSeed: z.string().optional(),
});
